import { useDispatch, useSelector } from "react-redux";
import "./BannerNotification.scss";
import moment from "moment";
import { fetchHealthAnalysisSlice } from "../../../rtk-query/features/healthAnalysis/healthAnalysisSlice";
import { HttpStatusCode } from "axios";
import {
  setIsFhsAvailable,
  setIsMarketing,
  setIsPro,
} from "../../../Redux/subscriptionSlice";
import { setHealthAnalysisID } from "../../../Redux/orgDetailsSlice";
import { useNavigate } from "react-router-dom";
import { Skeleton } from "primereact/skeleton";
import PropTypes from "prop-types";

const BannerNotification = ({ newAnalysis, setNewAnalysis }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dashboardReducer = useSelector((state) => state.dashboardReducer);
  const orgReducer = useSelector((state) => state.orgReducer);
  const healthAnalysisID = orgReducer?.healthAnalysisID?.uid;

  const dateRange = `${moment(
    dashboardReducer?.currentDashboardRange?.MinDate,
  ).format("MMM YY")} - ${moment(
    dashboardReducer?.currentDashboardRange?.MaxDate,
  ).format("MMM YY")}`;

  const handleRefresh = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    const response = await dispatch(
      fetchHealthAnalysisSlice({
        orguid: orgReducer?.selectedFI?.orgClientId,
        type: "refresh",
      }),
    );

    if (response?.payload?.statusCode === HttpStatusCode.Ok) {
      const successfullUid =
        response?.payload?.data?.length > 0
          ? response?.payload?.data?.find(
              (item) => item?.status?.toLowerCase() === "complete",
            )
          : null;
      if (successfullUid?.status?.toLowerCase() === "complete") {
        dispatch(setIsFhsAvailable(true));
        dispatch(setIsPro(true));
        dispatch(setIsMarketing(true));
        dispatch(setHealthAnalysisID(successfullUid));
        setNewAnalysis(null);
        return navigate(`/bank/health-analysis/report/${successfullUid?.uid}`, {
          state: {
            orguid: orgReducer?.selectedFI?.orgClientId,
          },
        });
      } else {
        dispatch(setIsFhsAvailable(true));
        dispatch(setIsPro(false));
        dispatch(setIsMarketing(false));
        return navigate(`/bank/health-analysis/report/no-analysis-id`, {
          state: {
            orguid: orgReducer?.selectedFI?.orgClientId,
          },
        });
      }
    }
  };

  return (
    <div className="toast-notification">
      <div className="container px-5">
        <div
          className={`analysis-wrapper d-flex align-items-stretch ${
            newAnalysis ? "with-new" : "center-only"
          }`}
        >
          {newAnalysis && (
            <div className="new-analysis enter-from-left">
              <span>
                {`${newAnalysis?.data} `}
                <button
                  type="button"
                  onClick={handleRefresh}
                  className="border-0 bg-transparent btn btn-link p-0"
                >
                  Refresh Now &#10140;
                </button>
              </span>
            </div>
          )}

          <div
            className={`current-analysis ${
              newAnalysis ? "slide-in-right" : "center-fade"
            } ${healthAnalysisID === "no-analysis-id" ? "d-none" : ""}`}
          >
            {dashboardReducer?.currentDashboardRange?.MinDate &&
            dashboardReducer?.currentDashboardRange?.MaxDate ? (
              <span>{`Analytics on this page are based on the date range: ${dateRange}`}</span>
            ) : (
              <Skeleton width="40rem" height="2rem" />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

BannerNotification.propTypes = {
  newAnalysis: PropTypes.shape({
    data: PropTypes.string,
  }),
  setNewAnalysis: PropTypes.func,
};

export default BannerNotification;
